import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=066b6ea2"
import script from "./Balance.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Balance.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./Balance.vue?vue&type=style&index=0&id=066b6ea2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports